import React, { useState, useRef, useEffect } from 'react';
import http from 'src/services/httpService';
import Button from '../button';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Form } from '../../utils/form';
import { KEYS } from '../../utils/keydown-decorator';
import Dialog from '../../componentes/dialog';
import Drawer from '../drawer/index.js';
import cloneDeep from 'lodash/cloneDeep';
import { capitalizeFirstLetter } from '../../utils/string';
import { getZIndexAboveDialog } from '../../utils/zIndexOverlay';
import focusManager from '../../utils/focus-manager';
import Input from '../input';

export const SearchQueryContext = React.createContext(null);

const mergeFilteredVlrs = (currentFilter, listaCamposCustomizados) => {
  const currentFilterClone = cloneDeep(currentFilter);
  const listaCamposCustomizadosClone = cloneDeep(listaCamposCustomizados);
  try {
    for (
      let i = 0;
      i < currentFilterClone.valor.camposCustomizados.length;
      i++
    ) {
      const e = currentFilterClone.valor.camposCustomizados[i];
      let campoCustomizado = listaCamposCustomizadosClone.find(
        (l) => l.idCampo == e.campo.id
      );
      if (campoCustomizado) {
        campoCustomizado.campo.valores = e.campo.valores;
        campoCustomizado.valor = e.valor;
      }
    }
  } catch (err) {
    console.error(err);
  }

  return listaCamposCustomizadosClone;
};

function FiltroDrawerNew(props) {
  const {
    searchComponent,
    model,
    tipoLayout,
    handleClose,
    isOpen,
    tipoItem,
    enableSearch = false,
    ...rest
  } = props;

  const intl = useIntl();
  const filter = useSelector((state) => state.filter);

  const other = { ...rest, filter };

  const [currentFilter, setCurrentFilter] = useState(() =>
    props.modelValue &&
    !(props.selectedFilter && props.selectedFilter.valor)
      ? props.modelValue
      : cloneDeep(props.selectedFilter)
  );
  const [searchQuery, setSearchQuery] = useState('');
  const [zIndexCalculado] = useState(() => getZIndexAboveDialog());
  const [focusTrapPriorityCalculada] = useState(
    () => focusManager.getTopPriority() + 0.5
  );
  const [, forceUpdate] = useState(0);
  const componentAdapter = useRef({
    state: {},
    setState(updater) {
      const partial =
        typeof updater === 'function' ? updater(this.state) : updater;
      Object.assign(this, { state: { ...this.state, ...partial } });
      forceUpdate((n) => n + 1);
    },
  });

  const formRef = useRef(null);
  if (!formRef.current) {
    let modelInicial;
    if (props.modelValue) {
      modelInicial =
        props.modelValue &&
        !(props.selectedFilter && props.selectedFilter.valor)
          ? props.modelValue
          : props.selectedFilter && cloneDeep(props.selectedFilter.valor);
    } else {
      modelInicial = props.selectedFilter ? props.defaultFilter : {};
    }

    formRef.current = new Form({
      component: componentAdapter.current,
      schema: props.searchSchema,
      model: modelInicial
        ? modelInicial
        : props.modelValue &&
          !(props.selectedFilter && props.selectedFilter.valor)
        ? props.modelValue
        : props.selectedFilter && cloneDeep(props.selectedFilter.valor),
    });
  }
  const form = formRef.current;

  const dialogRef = useRef(null);

  const obterCamposCustomizados = (currentFilterLocal) => {
    if (props.tipoItem) {
      http
        .post(`/CampoCustomizado/ObterListaCamposCustomizados`, {
          tipoItem: props.tipoItem,
        })
        .then((response) => {
          if (
            form.getModel('camposCustomizados') &&
            response.data.length > 0
          ) {
            let lista = form.getModel('camposCustomizados').value;
            if (
              !lista ||
              lista == undefined ||
              (lista != null &&
                lista != undefined &&
                (lista[0].tipoItem == response.data[0].tipoItem ||
                  lista[0].campo.tipoItem == response.data[0].tipoItem))
            ) {
              setCurrentFilter({
                ...currentFilterLocal,
                valor: {
                  camposCustomizados: mergeFilteredVlrs(
                    currentFilterLocal,
                    response.data
                  ),
                },
              });
              form
                .getModel('camposCustomizados')
                .requestChange(
                  mergeFilteredVlrs(currentFilterLocal, response.data)
                );
            } else {
              form.getModel('camposCustomizados').requestChange(null);
            }
          } else {
            setCurrentFilter({
              ...currentFilterLocal,
              valor: {
                ...(currentFilterLocal?.valor || {}),
                camposCustomizados: null,
              },
            });

            if (form.getModel('camposCustomizados')) {
              form.getModel('camposCustomizados').requestChange(null);
            }
          }
        });
    } else {
      setCurrentFilter({
        ...currentFilterLocal,
        valor: {
          ...(currentFilterLocal?.valor || {}),
          camposCustomizados: null,
        },
      });

      if (form.getModel('camposCustomizados')) {
        form.getModel('camposCustomizados').requestChange(null);
      }
    }
  };

  useEffect(() => {
    if (currentFilter && currentFilter.valor && !props.ignorarCamposCustomizados) {
      obterCamposCustomizados(currentFilter);
    } else {
      setCurrentFilter({
        ...currentFilter,
        valor: props.search,
      });
    }

    if (!props.ignorarCamposCustomizados) obterCamposCustomizados(currentFilter);
  }, []);

  const handleSaveFilter = async () => {
    if (props.onChangeUrl && props.modelValue) {
      props.onChangeUrl(form.getValue());
    } else {
      let novoFiltro = currentFilter;
      novoFiltro.valor = form.getValue();

      if (props.usarFiltroSalvo) {
        await http
          .post(`/FiltroColaborador/${props.filtroId}/SalvarFiltro`, {
            ...novoFiltro,
            filtroId: props.filtroId,
          })
          .then((response) => {
            const url = new URL(window.location.href);

            if (url.searchParams.has('filtroFavoritoId')) {
              url.searchParams.delete('filtroFavoritoId');
              window.location.replace(url.toString());
            }

            props.onSearch && props.onSearch(response.data);
          })
          .catch(() => {});
      } else {
        props.onSearch && props.onSearch(form.getValue(), true);
      }
    }

    // FECHAMENTO CONDICIONAL baseado no tipo
    if (props.tipoLayout === 'drawer') {
      props.handleClose && props.handleClose();
    } else {
      dialogRef.current && dialogRef.current.close();
    }
  };

  const handleSaveFilterRef = useRef(handleSaveFilter);
  handleSaveFilterRef.current = handleSaveFilter;

  useEffect(() => {
    const keyDownListener = (e) => {
      const keyCode = e.which || e.keyCode;
      if (
        e.altKey &&
        keyCode === KEYS.ENTER &&
        !(e.target.tagName === 'TEXTAREA' && keyCode === KEYS.ENTER)
      ) {
        handleSaveFilterRef.current(e);
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', keyDownListener);
    return () => document.removeEventListener('keydown', keyDownListener);
  }, []);

  const handleClearFilter = () => {
    const fields = form && form.getValue();

    for (var item in fields) {
      var campo = form.getModel(item);

      if (campo.value === true || campo.value === false) {
        form.setValue(item, false);
      } else if (item === 'camposCustomizados') {
        const array = form.getModel('camposCustomizados').value;
        if (!Array.isArray(array)) {
          form.getModel('camposCustomizados').requestChange(null);
          continue;
        }

        const newList = Object.assign([], array);

        newList.map((campoCustomizado) => {
          if (campoCustomizado.campo.multiSelecao) {
            campoCustomizado.campo.valores = null;
          } else if (campoCustomizado.campo.tipo.id === 5) {
            campoCustomizado.valor = null;
          } else {
            campoCustomizado.valor = '';
          }
        });

        form.getModel('camposCustomizados').requestChange(newList);
      } else {
        form.setValue(item, null);
      }
    }
  };

  const actions = [
    <Button
      key="btnFiltrar"
      onClick={handleSaveFilter}
      className="pull-right"
      leftIcon="magnify"
    >
      {intl.formatMessage({ id: 'label.filtrar' })}
    </Button>,
  ];

  const footerButton = (
    <div className="pt-1">
      <a className="text-primary" onClick={handleClearFilter}>
        {intl.formatMessage({ id: 'limparTodos' })}
      </a>
    </div>
  );

  let modelDefault = form.getModel();

  if (props.useFieldModels && props.searchSchema) {
    modelDefault = {};
    const schemaFields = props.searchSchema.fields || {};
    Object.keys(schemaFields).forEach((key) => {
      modelDefault[key] = form.getModel(key);
    });
  }

  const content = enableSearch ? (
    <SearchQueryContext.Provider value={{ searchQuery, intl }}>
      <div>
        {/* Campo de busca */}
        <div
          style={{
            marginBottom: 20,
          }}
        >
          <Input
            model={{
              label: null,
              value: searchQuery,
              requestChange: (value) => {
                setSearchQuery(value);
              },
            }}
            placeholder={intl.formatMessage({ id: 'labelPesquisarFiltros' })}
            showLabel={false}
            style={{
              width: '100%',
            }}
          />
        </div>

        {searchComponent &&
          React.cloneElement(searchComponent, {
            ...other,
            tipoItemId: tipoItem,
            model: model ? model : modelDefault,
          })}
      </div>
    </SearchQueryContext.Provider>
  ) : (
    <div>
      {searchComponent &&
        React.cloneElement(searchComponent, {
          ...other,
          tipoItemId: tipoItem,
          model: model ? model : modelDefault,
        })}
    </div>
  );

  // RENDERIZAÇÃO CONDICIONAL baseada no
  if (tipoLayout === 'drawer') {
    // Actions para o footer do drawer
    const drawerActions = (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <span
          style={{
            color: '#0D7E94',
            cursor: 'pointer',
            fontSize: 16,
            fontWeight: 'bold',
          }}
          onClick={handleClearFilter}
        >
          {intl.formatMessage({ id: 'limparTodos' })}
        </span>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            leftIcon="magnify"
            style={{
              width: '5rem',
            }}
            color="primary"
            onClick={handleSaveFilter}
          >
            {intl.formatMessage({ id: 'label.filtrar' })}
          </Button>
        </div>
      </div>
    );

    return (
      <Drawer
        open={isOpen}
        close={handleClose}
        zIndex={props.zIndex ?? zIndexCalculado}
        actions={drawerActions}
        title={
          <div
            className="font-weight-bold pt-4 pb-4"
            style={{
              fontSize: '1.5rem',
              color: '#404040',
              fontWeight: 700,
            }}
          >
            {capitalizeFirstLetter(intl.formatMessage({ id: 'filtros' }))}
          </div>
        }
        padding={true}
        headerStyle={{
          borderBottom: '1px solid #e4eaec',
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 0,
          paddingBottom: 0,
        }}
        bodyStyle={{
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        actionsStyle={{ borderTop: '1px solid #e4eaec', padding: 20 }}
        focusTrap={props.focusTrap ?? true}
        focusTrapPriority={
          props.focusTrapPriority ?? focusTrapPriorityCalculada
        }
      >
        <div>{content}</div>
      </Drawer>
    );
  }

  return (
    <Dialog
      title={intl.formatMessage({ id: 'filtros' })}
      ref={dialogRef}
      {...other}
      actions={actions}
      footer={footerButton}
    >
      {content}
    </Dialog>
  );
}

export default FiltroDrawerNew;
